<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      SMS Camping
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="4">
        <!-- <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            :max="nowDate"
          ></v-date-picker>
        </v-menu> -->
      </v-col>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        :actions="actions"
        dense
        :loading="loading"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        mobile-breakpoint="0"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        
        

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      date: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      menu2: false,
      loading: true,
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Patient_id",
          value: "patient_id",
        },
        { text: "Phone Number", sortable: true, value: "send_number" },
        // { text: "OT Date", value: "opp_date", Key: "Date" },
        { text: "Response", value: "response" },
        { text: "attempt", value: "attempt" },

        // { text: "Create at", value: "create_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],
      
      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "SMS",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
  },
  methods: {
    initialize() {
      atshq
        .get("sms/campign")
        .then((response) => {
          // JSON responses are automatically parsed.
          this.desserts = response.data.data;
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    dateSelect(date) {
      this.initialize(date);
    },
    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    nextSort() {
      let index = this.headers.findIndex((h) => h.value === this.sortBy);
      index = (index + 1) % this.headers.length;
      this.sortBy = this.headers[index].value;
    },
    getColor(status) {
      if (status == "open") return "orange";
      else if (status == "close") return "green";
      else if (status == "cancel") return "red";
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
      // console.log(this.desserts.item);
      alert(item.patient_id);
    },
    create_invoice(item) {
      window.location.href = "/otbill-create/" + item.registration_no;
    },
    recieve_money(item) {
      window.location.href = "otbill-received/" + item.registration_no;
      // window.location.href =
      //   this.returnUrl +
      //   "front_desk/invoice/" +
      //   item.registration_no +
      //   "#otbillarea";
    },
    otbillview(item) {
      window.open(
        this.returnUrl + "printdoc/invoiceDoctorOt/" + item.registration_no
      );
    },
    admissionform(item) {
      window.open(
        this.returnUrl +
          "printdoc/opAdmissionFormRegNo/" +
          item.registration_no +
          "/0"
      );
    },
    injection(item) {
      window.open(
        this.returnUrl +
          "printdoc/avs_injectionRegNo/" +
          item.registration_no +
          "/0"
      );
    },
    yaglaser(item) {
      window.open(
        this.returnUrl + "printdoc/yagLaserRegNo/" + item.registration_no + "/0"
      );
    },
    laserChart(item) {
      window.open(
        this.returnUrl +
          "printdoc/laserProformaRegNo/" +
          item.registration_no +
          "/0"
      );
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
  },
};
</script>